import Grid from "@mui/material/Grid";
import React, { useEffect, useState } from "react";
import { OrderTile } from "../orderTile/orderTile";
import { faCodeCompare, faMobileScreen, faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { getDataFromCache } from "../../services/cachingService";
import { ChannelkartNetworkGet } from "../../services/networkService";
import { Loader } from "../../components/loader/Loader";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { fetchUserAnalytics } from "../../services/analyticsService";
import { getMetaDataConfig } from "../../services/uiConfigService";

export function UserAnalytics() {
  const { translate } = usePortalTranslation();
  const [awareTotal, setAwareTotal] = useState<string>("0");
  const [onboardingTotal, setOnboardingTotal] = useState<string>("0");
  const [repeatTotal, setRepeatTotal] = useState<string>("0");
  const [adoptedTotal, setAdoptedTotal] = useState<string>("0");

  const [loading, setLoading] = useState<boolean>(false);

  const getData = async () => {
    setLoading(true);
    try {
      const portalConfig: Record<string, any> = await getMetaDataConfig("clientConfig", "portal_configuration");
      let saleslens: boolean = false;
      if(portalConfig){
      for (const key of portalConfig?.domainValues) {
        if(key?.name === "fetchFromSaleslens"){
          saleslens=key?.value
        }
      };
      }
      const aware: Record<string, any> = await getCustomQuery("AwareTotal");
      setAwareTotal(aware?.data?.features[0]?.value || 0);
      if(saleslens){
        const userData = await fetchUserAnalytics()
        setOnboardingTotal(userData?.outletstats?.onboarded || 0)
        setRepeatTotal(userData?.outletstats?.repeated || 0)
        setAdoptedTotal(userData?.outletstats?.adopted || 0)
      }else{
        const onboarding: Record<string, any> = await getCustomQuery("OnboardingTotal");
        setOnboardingTotal(onboarding?.data?.features[0]?.value || 0);
        const repeat: Record<string, any> = await getCustomQuery("RepeatTotal");
        setRepeatTotal(repeat?.data?.features[0]?.value || 0);
        const adopted: Record<string, any> = await getCustomQuery("AdoptedTotal");
        setAdoptedTotal(adopted?.data?.features[0]?.value || 0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  async function getCustomQuery(queryName: string) {
    let url = `/v1/query/${queryName}?callType=scheduled`;
    try {
      const queryResponse = await getDataFromCache(url, 15, async () => {
        const response = await ChannelkartNetworkGet(url);
        if (response.status === 200) {
          return response;
        } else {
          return [];
        }
      });
      return queryResponse;
    } catch (err) {
      return [];
    }
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="box-container">
      {
        loading ? <Loader /> :
          <div className="tile-container">
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item lg={3} sm={6} xs={12}>
                <OrderTile
                  heading={`${translate(TranslationEnum.analytics, "AWARE")} (${translate(TranslationEnum.analytics, "Clicked Once")})`}
                  subHeading={translate(TranslationEnum.analytics, "Total")}
                  footerHeading={""}
                  img={faMobileScreen}
                  callApi={false}
                  orderPrimaryValue={awareTotal}
                />
              </Grid>
              <Grid item lg={3} sm={6} xs={12}>
                <OrderTile
                  heading={`${translate(TranslationEnum.analytics, "ONBOARDED")} (${translate(TranslationEnum.analytics, "Min One Order")})`}
                  subHeading={translate(TranslationEnum.analytics, "Total")}
                  footerHeading={""}
                  img={faUser}
                  callApi={false}
                  orderPrimaryValue={onboardingTotal}
                />
              </Grid>
              <Grid item lg={3} sm={6} xs={12}>
                <OrderTile
                  heading={translate(TranslationEnum.analytics, "REPEAT ORDER")}
                  subHeading={translate(TranslationEnum.analytics, "Total")}
                  footerHeading={""}
                  img={faCodeCompare}
                  callApi={false}
                  orderPrimaryValue={repeatTotal}
                />
              </Grid>
              <Grid item lg={3} sm={6} xs={12}>
                <OrderTile
                  heading={`${translate(TranslationEnum.analytics, "ADOPTED")} (${translate(TranslationEnum.analytics, "3+ Order")})`}
                  subHeading={translate(TranslationEnum.analytics, "Total")}
                  footerHeading={""}
                  img={faUsers}
                  callApi={false}
                  orderPrimaryValue={adoptedTotal}
                />
              </Grid>
            </Grid>
          </div>
      }
    </div>
  );
}